import React, { useContext, useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';
import { estadoCivil, sexo, tipoDocumentos } from '../../data/mochaData';
import useToken from '../../hooks/useToken';
import http from '../../services/http';
import { amaDeCasa, endPoints, estudiante, tipoId } from '../../utils/constanst';
import CustomSelect from '../controls/CustomSelect';
import DateControl from '../controls/DateControl';
import DropDownInput from '../controls/DropDownInput';
import Input from '../controls/Input';
import InputFile from '../controls/InputFile';
import InputSelect from '../controls/InputSelect2';
import SwitchButton from '../controls/SwitchButton';
import {existeCoberturaEquipoEspecial} from '../../data/cotizadorCrData'; 

const Step7 = ({ ...rest }) => {

    const { poliza, catalogos,tarificacion, setPoliza, polizaChangeHandler, setCatalogos, init } = useContext(CotizadorCRDataContext);

    const { auFiles } = poliza;

    const [requiredEquipoEspecial] = useState(existeCoberturaEquipoEspecial(tarificacion));

    useEffect(() => {

        if (init) {
            cargarCatalogos(poliza.planId);

        }
    }, [init]);

    const cargarCatalogos = async (planId) => {
        const [transmision, clasevh, nopuertas, cilindros, combustible] = await Promise.all([
            http(endPoints.vhTransmision).get(),
            http(endPoints.vhClaseVehiculo).get(),
            http(endPoints.vhNoPuertas).get(),
            http(endPoints.vhCilindros).get(),
            http(endPoints.vhCombustible).get(),
        ]);
        setCatalogos({ transmision, clasevh, nopuertas, cilindros, combustible });

    }

    const onChangeFiles = (id, newFile) => {

        const { auFiles } = poliza;

        if (!id.startsWith('file') || id.length <= 4)
            return;

        let index = id.substring(4);

        auFiles[index] = newFile

        setPoliza({ ...poliza, auFiles });

    }


    return (
        <div className="reponsive">
            <div className="reponsive-width-12 box-pl5-pr5 lfheader">
                <label>Datos del Vehículo</label>
            </div>
            <div className="reponsive-width-6">
                <div className="box-pl5-pr5">
                    
                    <InputFile id="file0"
                        label='RTV, Factura proforma, carta compra/venta'
                        handlerFiles={onChangeFiles}
                        file={auFiles[0]}
                        part='factura proforma'
                        info='RTV y/o carta compra venta para vehículos usados, o proforma/factura para vehículos nuevos.' />

                    <InputFile isRequired={requiredEquipoEspecial} id="file1" label='Factura de equipos especiales (si aplica)' handlerFiles={onChangeFiles} file={auFiles[1]} part='factura equipos especiales' />
                    <Input label='Placa' field='placa' value={poliza.placa} onChange={polizaChangeHandler} />
                    <Input label='Motor' field='motor' value={poliza.motor} onChange={polizaChangeHandler} />
                    <InputSelect label='Transmisión' field='transmision' value={poliza.transmision} dataProvider={catalogos.transmision} onChange={polizaChangeHandler} containBlank={true} />
                    <InputSelect label='Clase de vehículo:' field='clasevh' value={poliza.clasevh} dataProvider={catalogos.clasevh} onChange={polizaChangeHandler} containBlank={true} />
                </div>
            </div>
            <div className="reponsive-width-6">
                <div className="box-pl5-pr5">

                    <InputSelect label='No. de puertas' field='npuertas' value={poliza.npuertas} onChange={polizaChangeHandler} dataProvider={catalogos.nopuertas} containBlank={true}  />
                    <Input label='Chasis' field='chasis' value={poliza.chasis} onChange={polizaChangeHandler} />
                    <Input label='Color' field='color' value={poliza.color} onChange={polizaChangeHandler} /> 
                    <InputSelect label='No. de cilindro' field='ncilindros' value={poliza.ncilindros} onChange={polizaChangeHandler} dataProvider={catalogos.cilindros} containBlank={true} />
                    <InputSelect label='Combustible' field='combustible' value={poliza.combustible} onChange={polizaChangeHandler} dataProvider={catalogos.combustible}  containBlank={true}/>
                </div>
            </div>
            <ReactTooltip className='tipstyle' multiline={true} />
        </div>
    );
}

export default Step7;
